import React from 'react'
import { TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { type FormikContextType, useFormikContext, getIn } from 'formik'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { type AssetProjectUpdateDto } from '../../../api-schema-types/assets/AssetProjectCrudDtos'

import { DATE_FORMAT_API } from '../../../utility/formatters/DateFormatter'
import { FormikFieldErrors } from './FormikFieldErrors'

interface DateFieldProps {
  fieldName: string
  label: string
  locked: boolean
}

const FormikDateField: React.FC<DateFieldProps> = ({ fieldName, label, locked }: DateFieldProps) => {
  const formik: FormikContextType<AssetProjectUpdateDto> = useFormikContext()
  const formikErrors = new FormikFieldErrors(formik)

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          inputFormat={DATE_FORMAT_API}
          disableMaskedInput={true}
          renderInput={(props) => (
            <TextField {...props}
                       className={'w-100'}
                       error={formikErrors.fieldInError(fieldName)}
                       helperText={formikErrors.getError(fieldName)} />)}
          label={label}
          value={getIn(formik.values, fieldName)}
          onChange={(newValue: any) => {
            formik.setFieldValue(fieldName, newValue)
          }}
          // error={GeneralHelper.formFieldHasError(formik, 'lifecycleDates.campaignEnds')}
          disabled={locked}

        />
      </LocalizationProvider>
      {/* <FormHelperText>{formik.errors.lifecycleDates?.campaignEnds}</FormHelperText> */}
    </>
  )
}

export default FormikDateField
